import React from "react";
import { Col, Container, Row } from "reactstrap";

const Download = () => {
  return (
    <section className='download-bg'>
      <Container>
        <Row>
          <Col xl={3} className='display-flex'>
            <div className='footer-logo'>
              <img src='assets/images/footer-logo.png' alt='footer-logo' className='img-fluid' />
            </div>
          </Col>
          <Col xl={5} className='display-flex'>
            <div className='download-text'>
              <h3>Download the Chatloop app and enjoy it</h3>
            </div>
          </Col>
          <Col xl={4} className='display-flex'>
            <div className='download-img'>
              <ul>
                <li>
                  <img src='assets/images/app1.png' alt='foot-app' className='img-fluid' />
                </li>
                <li>
                  <img src='assets/images/app2.png' alt='foot-app1' className='img-fluid' />
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Download;
